import { i as f, x as l } from "../../lit-element-6iugfgmM.js";
import { S as d } from "../../Base-pdJ5fkYW.js";
import { n as m } from "../../property-BWlAHqg_.js";
import { e as c } from "../../custom-element-wk-AooBb.js";
const u = f`:host{position:fixed;top:0;bottom:0;left:0;transform:translate(-100%);transition:transform .2s;width:200px}:host([expanded]){left:0;transform:translate(0)}`;
var x = Object.defineProperty, v = Object.getOwnPropertyDescriptor, i = (p, r, a, e) => {
  for (var s, t = e > 1 ? void 0 : e ? v(r, a) : r, n = p.length - 1; n >= 0; n--) (s = p[n]) && (t = (e ? s(r, a, t) : s(t)) || t);
  return e && t && x(r, a, t), t;
};
let o = class extends d {
  constructor() {
    super(...arguments), this.expanded = !1;
  }
  static get styles() {
    return u;
  }
  render() {
    return l`<nav><slot></slot></nav>`;
  }
};
i([m({ type: Boolean })], o.prototype, "expanded", 2), o = i([c("af-flyout-navigation")], o);
const O = o;
export {
  O as default
};
//# sourceMappingURL=FlyoutNavigation.js.map
